import { useEffect, useState } from "react";
import api from "../../api";
import { fmtCLP, fmtFecha } from "../../utils/formato";
import "../UserManager.css";

const BASE = "/api/insumos";

function today() {
  return new Date().toISOString().slice(0, 10);
}

function firstDayMonth() {
  const d = new Date();
  d.setDate(1);
  return d.toISOString().slice(0, 10);
}

export default function HistorialComprasInsumos() {
  const [list, setList] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [insumos, setInsumos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [filtros, setFiltros] = useState({
    desde: firstDayMonth(),
    hasta: today(),
    proveedor_id: "",
    insumo_id: "",
    categoria_id: "",
  });
  const [cargando, setCargando] = useState(false);
  const [detalleModal, setDetalleModal] = useState(null);

  const cargar = async () => {
    setCargando(true);
    try {
      const params = new URLSearchParams();
      if (filtros.desde) params.set("desde", filtros.desde);
      if (filtros.hasta) params.set("hasta", filtros.hasta);
      if (filtros.proveedor_id) params.set("proveedor_id", filtros.proveedor_id);
      if (filtros.insumo_id) params.set("insumo_id", filtros.insumo_id);
      if (filtros.categoria_id) params.set("categoria_id", filtros.categoria_id);
      const { data } = await api.get(`${BASE}/compras?${params.toString()}`);
      setList(Array.isArray(data) ? data : []);
    } catch (e) {
      setList([]);
    } finally {
      setCargando(false);
    }
  };

  const cargarDetalle = async (id) => {
    try {
      const { data } = await api.get(`${BASE}/compras/${id}`);
      setDetalleModal(data);
    } catch (_) {
      setDetalleModal(null);
    }
  };

  useEffect(() => {
    cargar();
  }, [filtros.desde, filtros.hasta, filtros.proveedor_id, filtros.insumo_id, filtros.categoria_id]);

  useEffect(() => {
    Promise.all([
      api.get(`${BASE}/proveedores`),
      api.get(`${BASE}/insumos`),
      api.get(`${BASE}/categorias`),
    ]).then(([p, i, c]) => {
      setProveedores(Array.isArray(p.data) ? p.data : []);
      setInsumos(Array.isArray(i.data) ? i.data : []);
      setCategorias(Array.isArray(c.data) ? c.data : []);
    }).catch(() => {});
  }, []);

  const totalPeriodo = list.reduce((s, c) => s + (Number(c.total) || 0), 0);

  return (
    <div className="um-wrapper">
      <div className="um-card">
        <div className="um-header">
          <h2>Historial de compras</h2>
          <span className="um-badge">{list.length} compras</span>
        </div>
        <div className="um-form" style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr auto", gap: 8, marginBottom: 16 }}>
          <div className="um-field">
            <label>Desde</label>
            <input type="date" value={filtros.desde} onChange={(e) => setFiltros({ ...filtros, desde: e.target.value })} />
          </div>
          <div className="um-field">
            <label>Hasta</label>
            <input type="date" value={filtros.hasta} onChange={(e) => setFiltros({ ...filtros, hasta: e.target.value })} />
          </div>
          <div className="um-field">
            <label>Proveedor</label>
            <select value={filtros.proveedor_id} onChange={(e) => setFiltros({ ...filtros, proveedor_id: e.target.value })}>
              <option value="">Todos</option>
              {proveedores.map((p) => <option key={p.id} value={p.id}>{p.nombre}</option>)}
            </select>
          </div>
          <div className="um-field">
            <label>Insumo</label>
            <select value={filtros.insumo_id} onChange={(e) => setFiltros({ ...filtros, insumo_id: e.target.value })}>
              <option value="">Todos</option>
              {insumos.map((i) => <option key={i.id} value={i.id}>{i.nombre}</option>)}
            </select>
          </div>
          <div className="um-field">
            <label>Categoría</label>
            <select value={filtros.categoria_id} onChange={(e) => setFiltros({ ...filtros, categoria_id: e.target.value })}>
              <option value="">Todas</option>
              {categorias.map((c) => <option key={c.id} value={c.id}>{c.nombre}</option>)}
            </select>
          </div>
        </div>
        {cargando && <p>Cargando…</p>}
        <div style={{ marginBottom: 8 }}>Total período: <strong>{fmtCLP(totalPeriodo)}</strong></div>
        <div className="um-table-wrap">
          <table className="um-table">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Proveedor</th>
                <th>Documento</th>
                <th>Forma pago</th>
                <th>Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {list.map((c) => (
                <tr key={c.id}>
                  <td>{c.fecha_compra}</td>
                  <td>{c.proveedor_nombre || "—"}</td>
                  <td>{[c.tipo_documento, c.numero_documento].filter(Boolean).join(" ") || "—"}</td>
                  <td>{c.forma_pago || "—"}</td>
                  <td>{fmtCLP(c.total)}</td>
                  <td>
                    <button type="button" className="um-btn um-btn-ghost" onClick={() => cargarDetalle(c.id)}>Ver detalle</button>
                  </td>
                </tr>
              ))}
              {list.length === 0 && !cargando && (
                <tr><td colSpan={6} className="um-empty">No hay compras en el período.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {detalleModal && (
        <div className="pm-modal-backdrop" style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }} onMouseDown={() => setDetalleModal(null)}>
          <div className="um-card" style={{ maxWidth: 520, maxHeight: "90vh", overflow: "auto" }} onMouseDown={(e) => e.stopPropagation()}>
            <div className="um-header">
              <h3>Compra #{detalleModal.id} – {detalleModal.fecha_compra}</h3>
              <button type="button" onClick={() => setDetalleModal(null)}>✕</button>
            </div>
            <p>Proveedor: {detalleModal.proveedor_nombre || "—"} | Doc: {detalleModal.tipo_documento} {detalleModal.numero_documento || ""} | Total: {fmtCLP(detalleModal.total)}</p>
            <table className="um-table">
              <thead>
                <tr>
                  <th>Insumo</th>
                  <th>Cant.</th>
                  <th>P. unit.</th>
                  <th>Subtotal</th>
                </tr>
              </thead>
              <tbody>
                {(detalleModal.detalle || []).map((d) => (
                  <tr key={d.id}>
                    <td>{d.insumo_nombre}</td>
                    <td>{d.cantidad} {d.unidad}</td>
                    <td>{fmtCLP(d.precio_unitario)}</td>
                    <td>{fmtCLP(d.subtotal)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
